// src/pages/Home.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import SearchBar from '../../components/SearchBar/SearchBar';
import Footer from '../../components/Footer/Footer';
import './home.css';

const categories = [
  { label: 'All', color: 'default' },
  { label: 'Anime', color: 'primary' },
  { label: 'Digital Art', color: 'secondary' },
  { label: 'Photography', color: 'success' },
  { label: 'AI Generated', color: 'error' },
  { label: 'Abstract', color: 'warning' },
  { label: 'Nature', color: 'info' },
];

const HomePage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const navigate = useNavigate();

  const handleSearch = ({ query, category }) => {
    if (query?.trim() || category !== 'All') {
      const searchParams = new URLSearchParams();
      if (query?.trim()) {
        searchParams.append('q', query);
      }
      if (category !== 'All') {
        searchParams.append('category', category);
      }
      navigate(`/explore?${searchParams.toString()}`);
    }
  };

  // JSON-LD structured data for better SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "InspiraPix",
    "description": "AI-powered platform for creating and discovering amazing artworks across various categories including anime, digital art, photography, and AI-generated content.",
    "applicationCategory": "Art & Design",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "category": "Art Generation Services"
    },
    "featureList": [
      "AI Image Generation",
      "Multiple Art Styles",
      "Category-based Search",
      "Digital Art Creation"
    ]
  };

  return (
    <>
      <Helmet>
        <title>InspiraPix - AI Art Generation Platform | Create Beautiful AI Art</title>
        <meta name="description" content="Transform your ideas into stunning artworks with InspiraPix's AI-powered art generation platform. Create unique digital art, anime, photography, and more." />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      
      <div className="home-wrapper">
        <main className="home-page">
          <section className="hero-section">
            <div className="home-header">
              <h1>Welcome to InspiraPix</h1>
              <h2>AI-Powered Art Generation Platform</h2>
              <p>Discover and get inspired by amazing artworks across multiple categories. Transform your ideas into stunning visuals using cutting-edge AI technology.</p>
            </div>
          </section>

          <section className="search-section" aria-label="Art Search">
            <div className="home-controls">
              <SearchBar
                onSearch={handleSearch}
                showFilters={false}
                showCategories={true}
                categories={categories}
                selectedCategory={selectedCategory}
                onCategoryChange={(category) => {
                  setSelectedCategory(category);
                  handleSearch({ category });
                }}
                className="home-search"
                aria-label="Search artworks by category"
              />
            </div>
          </section>

          <section className="features-section">
            <h2>Explore Our Features</h2>
            <div className="features-grid">
              <article className="feature-card">
                <h3>AI Art Generation</h3>
                <p>Create unique artworks using state-of-the-art AI technology</p>
              </article>
              <article className="feature-card">
                <h3>Multiple Styles</h3>
                <p>Choose from various art styles including anime, digital art, and photography</p>
              </article>
              <article className="feature-card">
                <h3>Community Gallery</h3>
                <p>Share your creations and get inspired by other artists</p>
              </article>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
